/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';

/**
 * @description No Content
 */
export const postApiForgotpassword204Schema = z.any();

export const postApiForgotpasswordMutationRequestSchema = z.object({
  email: z.coerce.string(),
});

export const postApiForgotpasswordMutationResponseSchema = z.lazy(
  () => postApiForgotpassword204Schema,
);
